module.exports = __webpack_public_path__ + "img/house_pv_panel_error_online.605ec540.png";